import React from "react"
import Layout from "../components/layout"
import { HorizontalSpacer } from "../helpers/omniElements"
import IntroModal from "../components/introModal"
import SEO from "../components/seo"
import EgrStaticBanner from "../components/staticHeaderBanner"
import EventWidget from "../components/eventWidgets"
import { BASE_URL } from "../helpers/constants"

const Homepage = props => {
  return (
    <>
      <SEO
        keywords="baby shower, baptism, birthday-adult, birthday-kids, birthday-debut, wedding, anniversary, house warming, others"
        imageUrl={`${BASE_URL}/images/event_logo_small.jpg`}
      />
      <Layout minHeight={"0rem"} {...props}>
        <EgrStaticBanner />
        <EventWidget />
        <HorizontalSpacer height={"2.4rem"} />
      </Layout>
      <IntroModal />
    </>
  )
}

export default Homepage
